import {ModalConfirm as ModalConfirmComponent, ModalConfirmFooter} from "./ModalConfirm";

export const ModalConfirm = Object.assign(ModalConfirmComponent, {
  Footer: ModalConfirmFooter,
})